export default __webpack_public_path__ + "static/media/fajer-noori-nastalique-regular.1fcf7f94.ttf";